import { Injectable } from '@angular/core'
import {
  MixingEvent,
  PayloadSpeedPatternStage,
  SpeedPatternStage,
} from '../types/mixing'

@Injectable({
  providedIn: 'root',
})
export class MixingHelpersService {
  constructor() {}

  public parseMixingPattern(
    speedPattern: string,
    speedPatternTime: string,
    timeoutEventPast: boolean,
  ) {
    let mixingEvent: MixingEvent = null
    const patternArray = this.parseSpeedPattern(speedPattern)
    if (patternArray.length) {
      const currentStageIndex = patternArray.findIndex(
        (stage) =>
          stage.status === 'preparing' || stage.status === 'in_progress',
      )

      mixingEvent = {
        status: 'in_progress',
        lastUpdateTimestamp: speedPatternTime,
        currentStageIndex: currentStageIndex,
        speedPattern: patternArray,
      }

      const allComplete = patternArray.reduce(
        (prev, stage) => (stage.status !== 'complete' ? false : prev),
        true,
      )
      if (allComplete) {
        mixingEvent.status = 'success'
      } else if (timeoutEventPast) {
        mixingEvent.status = 'fail'
      }
    }
    return mixingEvent
  }

  public parseSpeedPattern(pattern: string): SpeedPatternStage[] {
    try {
      let ret: SpeedPatternStage[] = []
      const val = pattern || ''
      if (val.startsWith('[')) {
        const temp: PayloadSpeedPatternStage[] = JSON.parse(val)
        if (temp && temp.length) {
          ret = temp.map(
            (item) =>
              ({
                secondsTarget: item.seconds_target,
                secondsElapsed: item.seconds_elapsed,
                rmpTarget: item.rpm_target,
                rpmMin: item.rpm_min,
                rpmMax: item.rpm_max,
                startTimestamp: item.start_timestamp_utc_seconds
                  ? new Date(
                      item.start_timestamp_utc_seconds * 1000,
                    ).toISOString()
                  : '',
                status: item.status,
              }) as SpeedPatternStage,
          )
        }
      }
      return ret
    } catch (e) {
      console.log('Error parsing SpeedPattern', e, pattern)
      return []
    }
  }
}
